import { Component, Input, OnInit } from '@angular/core';
import { GroupClassification } from '@app-model/group-classification';

@Component({
    selector: 'app-eligible-view',
    templateUrl: './eligible-view.component.html',
    styleUrls: ['./eligible-view.component.scss'],
    standalone: false
})
export class EligibleViewComponent implements OnInit {
  @Input() group: GroupClassification;
  UsersList = [];

  constructor() {}

  ngOnInit() {
  }
}
